$(document).ready(function(e){
  function activate2TierLinks(handle){
    var hasAlreadyPanelOpened = 0;
    if ($(".mega-content-2-tier-links.active").length > 0 ){
      hasAlreadyPanelOpened = 1;
    }
    
    if ( $(".mega-content-2-tier-links[data-handle='" + handle + "']").hasClass("active") ){
      $(".mega-content-2-tier-links").removeClass("active").removeClass("animation");
    }else{
      $(".mega-content-2-tier-links").removeClass("active").removeClass("animation");
      $(".mega-content-2-tier-links[data-handle='" + handle + "']").addClass("active");
      if ( hasAlreadyPanelOpened == 0){
        $(".mega-content-2-tier-links[data-handle='" + handle + "']").addClass("animation");
      }
    }
  }
  
  $("body").on("click", ".site-nav-top-menu .top-menu-item.has-mega-menu", function(event){
    event.stopPropagation();
    $("#site-nav--mega-menu").addClass("active");
    var handle = $(this).attr("data-handle");
    $(".mega-menu-top-navigation .navigation-item").removeClass("active");
    $(".mega-menu-top-navigation .navigation-item[data-handle='" + handle + "']").addClass("active");
    $(".mega-menu-main-content-item").removeClass("active");
    $(".mega-menu-main-content-item[data-handle='" + handle + "']").addClass("active");
  });

  $(".mega-content-left-column-item a.has-links").click(function(e){
    e.stopPropagation();
    e.preventDefault();
    if ( $(this).hasClass("has-links")){
      var handle = $(this).attr("data-handle");
      activate2TierLinks(handle);
    }
  });

  $(".mega-content-left-column-item a.has-links").hover(function(e){
    e.stopPropagation();
    e.preventDefault();

    console.log("hover in....");
    if ( $(this).hasClass("has-links")){
      var handle = $(this).attr("data-handle");
      activate2TierLinks(handle);
    }
  },                                        
  function(e){
    console.log("hover out");
  });
  
  $('#site-nav--mega-menu').click(function(event){
    event.stopPropagation();
  });

  $(window).click(function() {
    $("#site-nav--mega-menu").removeClass("active");
  });

  $(".mega-menu-top-navigation .navigation-item.has-mega-menu").click(function(e){
    var handle = $(this).attr("data-handle");
    $(".mega-menu-top-navigation .navigation-item").removeClass("active");
    $(".mega-menu-top-navigation .navigation-item[data-handle='" + handle + "']").addClass("active");
    $(".mega-menu-main-content-item").removeClass("active");
    $(".mega-menu-main-content-item[data-handle='" + handle + "']").addClass("active");
  });


  $("#site-nav--mobile .primary-mega-menu-item.has-mega-menu").click(function(e){
    var handle = $(this).attr("data-handle");
    $("#site-nav--mobile .secondary-menu").addClass("active");
    $("#site-nav--mobile .secondary-menu-content-item").removeClass("active");
    $("#site-nav--mobile .secondary-menu-content-item[data-handle='" + handle + "']").addClass("active");
    $("#site-nav--mobile .site-nav-header").addClass("active");
  });

  $("#site-nav--mobile .site-nav-header_btn_back").click(function(e){
    $("#site-nav--mobile .secondary-menu").removeClass("active");
    $("#site-nav--mobile .site-nav-header").removeClass("active");
  });

  $("#site-nav--mobile .secondary-menu-parent-link.has-child button").click(function(e){
    var parentLink = $(this).closest(".secondary-menu-parent-link");
    parentLink.toggleClass("expand");
  });
  
  
  
  

  customElements.define('shadow-root', class extends HTMLElement {      
    connectedCallback() {
      var style = document.createElement( 'style' );
      style.innerHTML = '.ls-sw-all{min-width: 50px !important;} .ls-sw-all > .active a{ padding-right: 10px !important} .ls-sw-currencies > .active a { padding-right: 10px !important; } .ls-sw-currencies{min-width: 20px !important;}   @media screen and (max-width: 480px){.ls-sw-languages > .active a .ls-icon{margin-right: 0px !important;} .ls-sw-languages > .active a .ls-text{display: none !important;}}';
      this.shadowRoot.appendChild( style );
    }
  });

  
  /*
  var localeSelectorTimer = setInterval(function(){
    if ( $(".locale-selectors__container").length > 0 ){
      $(".locale-selectors__container").appendTo("#header-currency-selector");
      clearInterval(localeSelectorTimer);
    }
  }, 500);
  */
  
  
  
  var iconWorldWidePath = "//www.venoom.com/cdn/shop/t/51/assets/icon-worldwide.svg?v=114134626480056106991785806400";
  var iconReturnsPath = "//www.venoom.com/cdn/shop/t/51/assets/icon-returns.svg?v=74496321384653766421785806400";
  var iconSecurePath = "//www.venoom.com/cdn/shop/t/51/assets/icon-secure.svg?v=136809248784162587351785806400";
  
  
  
  $(".popup-dog-detail .btn-close").click(function(e){
    $("body").removeClass("show-dog-detail");
  });
  
  $(".collection_dog_template .product-item-wrapper").click(function(e){
    
    if ( e.target.classList.contains("pedigree") || e.target.classList.contains("videos") || e.target.classList.contains("documents")){
      return;
    }
    
    e.preventDefault();
    $("body").addClass("show-dog-detail");
    
    var productHandle = $(this).closest(".product-item-wrapper").attr("data-handle");
    loadProductDetail(productHandle);
  });

  $(".our-dogs-section .image-items .image-item .item-button").click(function(e){    
    e.preventDefault();
    e.stopPropagation();
    $("body").addClass("show-dog-detail");
    
    var productHandle = $(this).closest(".image-item").attr("data-handle");
    loadProductDetail(productHandle);
  });

  $(".our-dogs-section .image-items .image-item .image-item-image").click(function(e){    
    e.preventDefault();
    e.stopPropagation();
    $("body").addClass("show-dog-detail");
    
    var productHandle = $(this).closest(".image-item").attr("data-handle");
    loadProductDetail(productHandle);
  });

  $(".frozen-new-section .image-items .image-item .item-button").click(function(e){    
    e.preventDefault();
    e.stopPropagation();
    $("body").addClass("show-dog-detail");
    
    var productHandle = $(this).closest(".image-item").attr("data-handle");
    loadProductDetail(productHandle);
  });

  $(".frozen-new-section .image-items .image-item .image-item-image").click(function(e){    
    e.preventDefault();
    e.stopPropagation();
    $("body").addClass("show-dog-detail");
    
    var productHandle = $(this).closest(".image-item").attr("data-handle");
    loadProductDetail(productHandle);
  });

  $(".dak-venoom-section .image-items .image-item .item-button").click(function(e){    
    e.preventDefault();
    e.stopPropagation();
    $("body").addClass("show-dog-detail");
    
    var productHandle = $(this).closest(".image-item").attr("data-handle");
    loadProductDetail(productHandle);
  });

  $(".dak-venoom-section .image-items .image-item .image-item-image").click(function(e){    
    e.preventDefault();
    e.stopPropagation();
    $("body").addClass("show-dog-detail");
    
    var productHandle = $(this).closest(".image-item").attr("data-handle");
    loadProductDetail(productHandle);
  });
  
  $("body").on("click", ".popup-dog-detail .product-tabs .product-tab .tab-header", function(e){
    $(this).closest(".product-tab").toggleClass("expanded");
  });
  
  $("body").on("click", ".popup-dog-detail .product-image .thumbnail", function(e){
    var index = $(this).attr("data-index");
    
    $(".popup-dog-detail .product-image .thumbnail").removeClass("selected");
    $(".popup-dog-detail .product-image .media").removeClass("selected");
    
    $(".popup-dog-detail .product-image .thumbnail[data-index='" + index + "']").addClass("selected");
    $(".popup-dog-detail .product-image .media[data-index='" + index + "']").addClass("selected");
    
  });
  
  
  
  function loadProductDetail(_handle){
    var linksHTML = $(".product-item-wrapper[data-handle='" + _handle + "'] .caption .links").html();
    var wdLink = $(".product-item-wrapper[data-handle='" + _handle + "'] .caption .wd_profile").html();
    $(".popup-dog-detail .popup-inner .popup-content").html("<div style='text-align:center;margin-top: 30px;width: 100%;'>Loading...</div>");

    $.getJSON('/products/' + _handle + '.js', function(product) {
      
      var html = "";
      html = '<div class="product-detail">';

      html +=   '<div class="product-image">';
      html +=		'<div class="thumbnails">';
      for(var i=0;i<product.images.length;i++){
        html +=	'<div class="thumbnail" data-index="' + i + '">';
        html +=		'<img data-src="' + product.images[i] + '" class="lazyload">';
        html +=	'</div>';

      }
      html +=		'</div>';

      html +=		'<div class="medias">';
      for(var i=0;i<product.images.length;i++){
        html +=	'<div class="media" data-index="' + i + '">';
        
        html +=		'<a href="' + product.images[i] + '" data-fancybox="product-popup-image-' + product.id + '">';
        html +=		'<img data-src="' + product.images[i] + '" class="lazyload">';
        html +=		'</a>';
        html +=	'</div>';

      }
      html +=		'</div>';
      html +=   '</div>';

      html +=	  '<div class="product-meta">';
      html +=		'<h2 class="product-title">';
      html +=			 product.title;
      
      if ( $.inArray("Female", product.tags) !== -1 || $.inArray("female", product.tags) !== -1 ){
        html +=			' ♀️';
      }
      else if ( $.inArray("Male", product.tags) !== -1 || $.inArray("male", product.tags) !== -1 ){
        html +=			' ♂️';
      }
      html +=		 '</h2>';
      html += 		'<div class="product-description">' + product.description + '</div>';

      html +=		'<div class="product-links">';
      html +=  		linksHTML;
      html +=		'</div>';
      /*
      html +=		'<div class="product-services">';
      html +=			'<div class="service-item">';
      html +=				'<div class="item-img"><img src="' + iconWorldWidePath + '"></div>';
      html +=				'<span class="item-title">Free worldwide shipping</span>';
      html +=			'</div>';
      html +=			'<div class="service-item">';
      html +=				'<div class="item-img"><img src="' + iconReturnsPath + '"></div>';
      html +=				'<span class="item-title">Free returns</span>';
      html +=			'</div>';
      html +=			'<div class="service-item">';
      html +=				'<div class="item-img"><img src="' + iconSecurePath + '"></div>';
      html +=				'<span class="item-title">Secure payments</span>';
      html +=			'</div>';
      html +=		'</div>';
      */

      
      html += 	    '<a class="button with-icon" href="/pages/get-in-touch"><span>Contact</span><span class="icon"><svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" style="width:21px; height: 10px;" viewBox="0 0 21 10"><path d="M21.000,5.000 L15.000,10.000 L15.000,6.000 L-0.000,6.000 L-0.000,4.000 L15.000,4.000 L15.000,0.000 L21.000,5.000 Z" /></svg></span></a>';
      if ( wdLink != "" ){
        html +=       '<a class="button with-icon button-wd-profile" href="' + wdLink + '"><span>WD Profile</span><span class="icon"><svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" style="width:21px; height: 10px;" viewBox="0 0 21 10"><path d="M21.000,5.000 L15.000,10.000 L15.000,6.000 L-0.000,6.000 L-0.000,4.000 L15.000,4.000 L15.000,0.000 L21.000,5.000 Z" /></svg></span></a>';
      }

      html +=	  '</div>';
      
      
      

      /*
      html +=     '<div class="product-tabs">';
      
      html +=		'<div class="product-tab">';
      html +=			'<div class="tab-header">';
      html +=				'<span class="title">Pedigree</span><span class="arrow"></span>';
      html +=			'</div>';
      html +=			'<div class="tab-body">';
      html +=				'<div class="body-content">';
      html +=					'sample content';
      html +=				'</div>';
      html +=			'</div>';
      html +=		'</div>';
      
      
      html +=		'<div class="product-tab">';
      html +=			'<div class="tab-header">';
      html +=				'<span class="title">X-Rays</span><span class="arrow"></span>';
      html +=			'</div>';
      html +=			'<div class="tab-body">';
      html +=				'<div class="body-content">';
      html +=					'sample content';
      html +=				'</div>';
      html +=			'</div>';
      html +=		'</div>';
      
      html +=		'<div class="product-tab">';
      html +=			'<div class="tab-header">';
      html +=				'<span class="title">Videos</span><span class="arrow"></span>';
      html +=			'</div>';
      html +=			'<div class="tab-body">';
      html +=				'<div class="body-content">';
      html +=					'sample content';
      html +=				'</div>';
      html +=			'</div>';
      html +=		'</div>';
      
      html +=		'<div class="product-tab">';
      html +=			'<div class="tab-header">';
      html +=				'<span class="title">Shipping</span><span class="arrow"></span>';
      html +=			'</div>';
      html +=			'<div class="tab-body">';
      html +=				'<div class="body-content">';
      html +=					'sample content';
      html +=				'</div>';
      html +=			'</div>';
      html +=		'</div>';
      
      html +=	  '</div>';
      */

      html += '</div>';


      $(".popup-dog-detail .popup-inner .popup-content").html(html);
      $(".popup-dog-detail .popup-inner .popup-content .product-image .thumbnail[data-index=0]").addClass("selected");
      $(".popup-dog-detail .popup-inner .popup-content .product-image .media[data-index=0]").addClass("selected");
      var links = $(".popup-dog-detail .popup-inner .popup-content .product-links a");
      
      for(var j=0;j<links.length;j++){
        $(links[j]).attr("data-fancybox", $(links[j]).attr("data-fancybox") + "_popup");
      }
    });
  }


$(".index-custom-image .header-items .header-item").click(function(e){
  var blockId = $(this).attr("data-id");
  $(".index-custom-image .header-items .header-item").removeClass("active");
  $(".index-custom-image .header-items .header-item[data-id='" + blockId + "']").addClass("active");
  
  $(".index-custom-image .text-items .text-item").removeClass("active");
  $(".index-custom-image .text-items .text-item[data-id='" + blockId + "']").addClass("active");
  
  $(".index-custom-image .image-column img").removeClass("active");
  $(".index-custom-image .image-column img[data-id='" + blockId + "']").addClass("active");
});

  /*
var customImageIndex = 1;
setInterval(function(){
  if ( customImageIndex > 3 ) customImageIndex = 1;
  $(".index-custom-image .header-items .header-item:nth-child(" + customImageIndex  + ")").trigger("click");
  customImageIndex++;
}, 5000);
  */

if ( window.innerWidth >= 768 ){
$('.product_photos [data-fancybox]').fancybox({
  thumbs : {
    autoStart : true,
    axis      : 'x'
  }
})
}else{
$('.product_photos [data-fancybox]').fancybox({
  thumbs : {
    autoStart : true,
  }
})
}

});


